export default {
  maxByteLength (max) {
    return (rule, value, callback) => {
      if (value !== undefined && value !== null && value !== '') {
        // eslint-disable-next-line no-control-regex
        if (value.replace(/[^\x00-\xff]/g, '010').length > max) {
          callback(new Error(`长度不能大于${max}个字节`))
        }
      }
      callback()
    }
  }
}
